import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../general.service';
import { DataService } from '../data.service';

declare var Hashes: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [
    './login.component.scss'
  ]
})

export class LoginComponent implements OnInit {

  public logo = "";
  public errorText = "";
  public displayError = false;
  public Username = "";
  public Password = "";
  public loginDisabled = false;

  constructor(
    public generalSvc: GeneralService,
    public dataSvc: DataService
  ) {
    // Set default values;
    this.logo = "https://www.iwcf.org/wp-content/uploads/2018/12/iwcflogo.png";
    this.Username = "";
    this.Password = "";

    this.onLoad();
  }

  ngOnInit() {
    // 
  }

  checkEnetsecure(){
    if(!this.dataSvc.enetsecureMobile && !this.dataSvc.enetsecureWeb){
      var mobileSecure = this.generalSvc.getUrlParam("enetsecuremobile");
      var localStorageExamMethod = localStorage.getItem("examMethod");
      if(mobileSecure == "1" || localStorageExamMethod == "enetsecuremobile"){
        this.dataSvc.enetsecureMobile = true;
        this.dataSvc.enetsecureWeb = false;
        localStorage.setItem("examMethod", "enetsecuremobile");
        document.getElementById("version").innerHTML += " - eNetSecure";
      }
      else{
        var webSecure = this.generalSvc.getUrlParam("enetsecureweb");
        if(webSecure == "1" || localStorageExamMethod == "enetsecureweb"){
          this.dataSvc.enetsecureMobile = false;
          this.dataSvc.enetsecureWeb = true;
          localStorage.setItem("examMethod", "enetsecureweb");
          document.getElementById("version").innerHTML += " - eNetSecure";
        }
        else{
          this.dataSvc.enetsecureMobile = false;
          this.dataSvc.enetsecureWeb = false;
          localStorage.setItem("examMethod", "web");
        }
      }
    }  
  }

  onLoad() {
    var errorParam = this.generalSvc.getUrlParam("err");

    if (errorParam === 0) {
      this.errorText = "You entered incorrect login details.";
      this.displayError = true;
    }
    else if (errorParam == 1) {
      this.errorText = "Please login to eNetAssess.";
      this.displayError = true;
    }
    else {
      this.displayError = false;
    }
    this.checkEnetsecure();

    var alreadyLoggedIn = this.generalSvc.getUrlParam("es");
    if(alreadyLoggedIn === "1"){
      this.errorText = "You’re already logged in on another device. Please sign out from that device to continue.";
      this.displayError = true;
    }


  }

  getMembership(pass, salt) {
      var SHA1 = new Hashes.SHA1().b64(pass);
      var SHA1ws = new Hashes.SHA1().b64_hmac(pass, salt);
      return SHA1ws;
  }

  checkLogin() {
    if (this.Username.indexOf("demo") > -1)
      this.Username = "demo";

    this.dataSvc.initLogin(this.Username, this.Password);
  }

  processLogin(query) {
    var scQuery = query.replace(/\+/g, "###plus###");
  }

  submitLogin() {
    this.loginDisabled = true;
    this.checkLogin();

    setTimeout(() => {
      this.loginDisabled = false;
    }, 2500);
  }
}